import React, { createRef } from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
import { withStyles } from '@material-ui/core/styles'
import { Box, Divider, Typography } from '@material-ui/core'
import { forwardTo } from '../../utils/helper'
import styles from './gs_calendar_style'

export class Calendar extends React.Component {
  state = {
    currentMonth: this.props.currentMonth ? this.props.currentMonth : new Date(),
    selectedDate: this.props.selectedDate ? this.props.selectedDate : new Date(),
    isPopViewShown: true,
    popViewXpos: '0',
    popViewYpos: '0',
    EventsList: [],
    eventsCount: {},
    PopTitle: '',
    PopPower: '',
    popupDetails: [],
    showOnTop: false,
    currentEvent: {}
  };


  constructor(props) {
    super(props)

    this.state.currentMonth = props.currentMonth
    this.state.EventsList = props.EventsList
    this.state.eventsCount = props.eventsCount
    this.wrapperRef = createRef()
    this.celDiv = createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.ONGOING_EVENT = 'in_progress'
    this.COMPLETED = 'completed'
    this.CANCELLED = 'cancelled'
    this.FAILED = 'failed'
    this.STOPPED = 'stopped'
    this.EVENT_TYPE = {
      BATTERY_DISCHARGE: 'Discharge Event',
      BATTERY_CHARGE: 'Charge Event',
      IDLE: 'Idle Event'
    }
    this.EVENT_SUBTYPE = {
      Charge_From_PV: 'Charge from PV',
      Charge_From_NetPV: 'Charge from Net PV',
      Charge_From_PV_Grid: 'Charge from PV and Grid',
      Discharge_To_Load: 'Discharge to Load',
      Discharge_To_Load_Grid: 'Discharge to Load and Grid',
      Discharge_To_NetLoad: 'Discharge to Net Load',
      Idle: 'Idle'
    }
  }

  static getDerivedStateFromProps(props) {
    const { currentMonth, EventsList, eventsCount } = props
    return {
      currentMonth: currentMonth,
      EventsList: EventsList,
      eventsCount: eventsCount
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
    document.addEventListener('scroll', this.handleScroll, true)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
    document.removeEventListener('scroll', this.handleScroll, true)
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({
        isPopViewShown: 'none',
      })
    }
  }

  renderHeader = () => {
    const dateFormat = "MMMM - YYYY"
    const { classes } = this.props

    return (
      <div className={`${classes.header}`}>
        <div className={`${classes.col} ${classes.colCenter}`}>
          <span>{moment(this.state.currentMonth, 'MM-DD-YYYY').format(dateFormat)}</span>
        </div>
      </div>
    )
  }

  renderWeekName() {
    const { classes } = this.props
    const weekNameAryVar = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    const days = []

    for (let i = 0; i < 7; i++) {
      days.push(
        <div className={`${classes.col} ${classes.colCenter}`} key={i}>
          {weekNameAryVar[i]}
        </div>
      )
    }

    return <div className={`${classes.days} ${classes.row}`}>{days}</div>
  }

  renderCells = () => {
    const { classes, enrollmentDate } = this.props
    const { selectedDate } = this.state
    const monthStart = moment(this.state.currentMonth, 'MM-DD-YYYY').startOf('month').format('MM-DD-YYYY')
    const monthEnd = moment(monthStart, 'MM-DD-YYYY').endOf('month').format('MM-DD-YYYY')
    const startDate = moment(monthStart, 'MM-DD-YYYY').startOf('week').format('MM-DD-YYYY')
    const endDate = moment(monthEnd, 'MM-DD-YYYY').endOf('week').format('MM-DD-YYYY')
    const dateFormat = "D"
    const rows = []

    let row = 1
    let days = []
    let day = `${startDate}`
    let formattedDate = ""

    while (moment(day, 'MM-DD-YYYY').isSameOrBefore(moment(endDate, 'MM-DD-YYYY'))) {
      for (let col = 0; col < 7; col++) {
        formattedDate = moment(day, 'MM-DD-YYYY').format(dateFormat)
        days.push(
          <div ref={this.celDiv}
            className={`${classes.col} ${classes.cell} ${this.getIndicatorColor(day, col, row) === '' ? classes.pointerEvent : ''}  ${!moment(day, 'MM-DD-YYYY').isSame(moment(monthStart, 'MM-DD-YYYY'), 'month')
              ? classes.disabled
              : moment(day, 'MM-DD-YYYY').isSame(moment(selectedDate, 'MM-DD-YYYY'), 'day') ? classes.selected : ""
              } ${enrollmentDate && ((moment(day, 'MM-DD-YYYY').diff(moment(moment(enrollmentDate, 'YYYY/MM/DD HH:mm:ss').format('YYYY/MM/DD'))) < 0 || moment(day, 'MM-DD-YYYY').diff(moment())) > 0 && classes.disbledTile)}`}
            key={day}
            onClick={this.onDateClick.bind(this, day, col, row)}
            onBlur={this.closePopView}>
            <span className={classes.number}>{formattedDate}</span>
            <div className={classes.indicator}
              style={{ background: this.getIndicatorColor(day, row, col) }}></div>
          </div>
        )
        day = moment(day, 'MM-DD-YYYY').add(1, 'day').format('MM-DD-YYYY')
      }
      rows.push(
        <div className={classes.row} key={day}>
          {days}
        </div>
      )
      row++
      days = []
    }
    return <div className={classes.body}>{rows}</div>
  }

  handleViewDetails = (id) => {
    forwardTo(`/programs/${this.props.programId}/events/${id}`)
  }

  renderEventDetails = (obj, index) => {
    const { classes, timeZone } = this.props
    const startTime = moment.tz(obj.startTime, timeZone).format('MMMM DD, YYYY hh:mm A Z')
    const endTime = moment.tz(obj.endTime, timeZone).format('hh:mm a')
    const eventStartTime = moment(_.get(obj, 'startTime', ''))
    const eventEndTime = moment(_.get(obj, 'endTime', ''))
    const duration = moment.duration(eventEndTime.diff(eventStartTime))
    const view = [
      {
        label: 'Event Name',
        value: _.get(obj, 'name', '')
      },
      {
        label: 'Event Type',
        value: this.EVENT_TYPE[obj.type]
      },
      {
        label: 'Event Sub Type',
        value: this.EVENT_SUBTYPE[obj.subtype]
      },
      {
        label: 'Event Start Time',
        value: startTime
      },
      {
        label: 'Event End Time',
        value: endTime
      },
      {
        label: 'Event Duration',
        value: _.get(obj, 'startTime', '') && _.get(obj, 'endTime', '') ? `${Math.floor(duration.asHours())} hour(s) ${moment.utc(duration.asMilliseconds()).format("mm")} minute(s)` : '--'
      },
      ...(this.props.page && this.props.page === 'Event' ? [] :
        [{
          label: 'Scheduled Power',
          value: _.get(obj, 'avg_kw_scheduled', '-')
        },
        {
          label: 'Scheduled Energy',
          value: _.get(obj, 'avg_kwh_scheduled', '-')
        },
        {
          label: 'Actual Power',
          value: _.get(obj, 'type', '') === 'BATTERY_CHARGE' ? _.get(obj, 'avg_kw_charged', '-') : _.get(obj, 'avg_kw_discharged', '-')
        },
        {
          label: 'Actual Energy',
          value: _.get(obj, 'type', '') === 'BATTERY_CHARGE' ? _.get(obj, 'avg_kwh_charged', '-') : _.get(obj, 'avg_kwh_discharged', '-')
        },
        {
          label: 'Opt In Status',
          value: obj && !_.isNil(obj['opt-in_status']) ? obj['opt-in_status'] === true ? 'Opted In' : 'Opted Out' : '-'
        }]
      )
    ]
    return (
      <Box>
        <Box className={classes.colWrapper}>
          {view.map(list => (
            <Box className={classes.rowWrapper}>
              <Typography className={classes.label}>{list.label}</Typography>
              <Typography className={classes.value}>{list.value}</Typography>
            </Box>
          ))}
        </Box>
        {obj.id ? <Typography className={classes.viewDetails} onClick={() => this.handleViewDetails(obj.id)}>View Event Details</Typography> :
          <Box mb={1}><Divider /></Box>
        }
      </Box>
    )
  }

  renderPopView = () => {
    const { classes } = this.props
    return <div className={classes.popView}
      style={{
        display: this.state.isPopViewShown,
        left: this.state.popViewXpos,
        ...(this.state.showOnTop ? { bottom: this.state.popViewYpos } : { top: this.state.popViewYpos }),
      }}
    >
      {this.state.popupDetails.map(this.renderEventDetails)}
    </div>
  }

  handleScroll = () => {
    if (this.state.isPopViewShown == 'block' && !_.isEmpty(this.state.currentEvent)) {
      let detail = this.state.currentEvent.getBoundingClientRect()

      let popViewXpos = (detail.left - 150) + 'px'
      let popViewYpos
      if ((window.innerHeight - detail.bottom) < 200) {
        popViewYpos = window.innerHeight - detail.top - 10 + 'px'
      } else {
        popViewYpos = (detail.bottom) + 10 + 'px'
      }

      this.setState({
        popViewXpos,
        popViewYpos,
        showOnTop: (window.innerHeight - detail.bottom) < 200,
      })
    }
  }

  onDateClick = async (day, col, row, event) => {
    event.persist()
    const { timeZone } = this.props
    let detail = event.currentTarget.getBoundingClientRect()

    let popViewXpos = (detail.left - 150) + 'px'
    let popViewYpos
    let events = []
    if ((window.innerHeight - detail.bottom) < 200) {
      popViewYpos = window.innerHeight - detail.top - 10 + 'px'
    } else {
      popViewYpos = (detail.bottom) + 10 + 'px'
    }
    if (this.props.page === 'Event') {
      events = await this.props.getEvents(day)
    }

    let eventDetails = []

    this.setState({
      popupDetails: [],
      isPopViewShown: 'none',
    })

    const eventsList = this.props.page === 'Event' && events ? events : this.state.EventsList
    eventsList.forEach(obj => {
      let startDate = moment(obj.start_date_time).tz(timeZone).format('MM-DD-YYYY') // new Date(obj.start_time)
      if (moment(day, 'MM-DD-YYYY').tz(timeZone).isSame(moment(startDate, 'MM-DD-YYYY').tz(timeZone), 'day')) {
        eventDetails.push({
          ...obj,
          name: obj.name,
          status: obj.status,
          startTime: _.get(obj, 'start_date_time', ''),
          endTime: _.get(obj, 'end_date_time', ''),
          type: _.get(obj, 'type', ''),
          id: _.get(obj, 'event_id', '') || _.get(obj, 'id', '')
        })
      }
    })

    if (!_.isEmpty(eventDetails)) {
      this.setState({
        popupDetails: eventDetails,
        selectedDate: day,
        isPopViewShown: 'block',
        popViewXpos,
        popViewYpos,
        showOnTop: (window.innerHeight - detail.bottom) < 200,
        currentEvent: event.currentTarget
      })
    }
  };

  getIndicatorColor = (day, row, col) => {
    const { EventsList, eventsCount } = this.state
    let selectedDay
    if (this.props.page === 'Event') {
      selectedDay = Object.keys(eventsCount).find(obj => {
        let startDate = moment(obj, 'YYYY-MM-DD').tz(this.props.timeZone).format('MM-DD-YYYY')
        return moment(day, 'MM-DD-YYYY').isSame(moment(startDate, 'MM-DD-YYYY'), 'day')
      })
    } else {
      selectedDay = EventsList && EventsList.find(obj => {
        let startDate = moment.tz(obj.start_date_time, this.props.timeZone).format('MM-DD-YYYY')
        return moment(day, 'MM-DD-YYYY').isSame(moment(startDate, 'MM-DD-YYYY'), 'day')
      })
    }

    if (_.isEmpty(selectedDay)) {
      return ''
    } else if (_.isBoolean(selectedDay['opt-in_status'])) {
      switch (selectedDay['opt-in_status']) {
        case true:
          return '#7ACF38'
        default:
          return '#FF6565'
      }
    } else if (eventsCount[selectedDay]) {
      if (eventsCount[selectedDay][this.ONGOING_EVENT])
        return '#EDCD1A'
      if (eventsCount[selectedDay][this.FAILED])
        return '#D82424'
      if (eventsCount[selectedDay][this.CANCELLED])
        return '#929699'
      if (eventsCount[selectedDay][this.STOPPED])
        return '#01B4DE'
      if (eventsCount[selectedDay][this.COMPLETED])
        return '#7ACF38'
      return '#0438E3'

    } else {
      switch (selectedDay.status) {
        case this.ONGOING_EVENT:
          return '#EDCD1A'
        case this.FAILED:
        case this.CANCELLED:
          return '#929699'
        case this.STOPPED:
        case this.COMPLETED:
          return '#7ACF38'
        default:
          return '#0438E3'
      }
    }
  }

  render() {
    const { classes } = this.props

    return <div className={classes.calendar} ref={this.wrapperRef} id="calendar_popup">
      {this.renderHeader()}
      {this.renderWeekName()}
      {this.renderCells()}
      {this.renderPopView()}
    </div>
  }
}

Calendar.defaultProps = {
  classes: {},
  programId: ''
}

export default (withStyles(styles)(Calendar))